<template>
  <div class="ui-pagination">
    <UiSelectPagination
      v-if="showSizeSelect"
      v-model="currentPageSize"
      :list="pageSizes"
    />

    <i
      class="ui-pagination__icon fas fa-chevron-double-left"
      :class="{ 'ui-pagination__icon_disabled': currentPage <= 1 }"
      @click="currentPage = 1"
    />
    <i
      class="ui-pagination__icon fas fa-chevron-left"
      :class="{ 'ui-pagination__icon_disabled': currentPage <= 1 }"
      @click="currentPage > 1 ? currentPage -= 1 : ''"
    />
    <UiInput
      v-model="currentPageInp"
      class="ui-pagination__page-input"
      @update:model-value="currentPageInpChangeDebounced"
    />
    <span class="ui-pagination__label-info">{{ $t('customReports.of') }} {{ totalPages || 1 }}</span>
    <i
      class="ui-pagination__icon fas fa-chevron-right"
      :class="{ 'ui-pagination__icon_disabled': currentPage >= totalPages }"
      @click="currentPage < totalPages ? currentPage += 1 : ''"
    />
    <i
      class="ui-pagination__icon fas fa-chevron-double-right"
      :class="{ 'ui-pagination__icon_disabled': currentPage >= totalPages }"
      @click="currentPage < totalPages ? currentPage = totalPages : ''"
    />
  </div>
</template>

<script>
export default {
  name: 'UiPagination',
  props: {
    page: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    pageSizes: {
      type: Array,
      default() {
        return [
          10,
          20,
          50,
          100,
        ];
      },
    },
    showSizeSelect: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['page-change'],
  data() {
    return {
      currentPage: this.page,
      currentPageInp: this.page,
      currentPageSize: this.pageSize,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.count / this.pageSize);
    },
    currentPageInpChangeDebounced() {
      return this.$_.debounce(this.currentPageInpChange, 500);
    },
  },
  watch: {
    page(value) {
      this.currentPage = value;
    },
    count() {
      if (parseInt(this.currentPage, 10) > this.totalPages) {
        this.currentPage = 1;
      }
    },
    currentPage(nv) {
      if (!nv || nv < 1 || nv > this.totalPages) {
        this.currentPage = 1;
      }

      this.currentPageInp = this.currentPage.toString();
      this.$emit('page-change', this.currentPage, this.currentPageSize);
    },
    // currentPageInp(nv) {
    //   this.currentPageInpChangeDebounced(nv);
    // },
    currentPageSize(nv) {
      this.currentPageSize = parseInt(nv, 10);
      this.currentPage = 1;
      this.$emit('page-change', this.currentPage, this.currentPageSize);
    },
  },
  methods: {
    resetPagination() {
      this.currentPage = 1;
    },
    currentPageInpChange(value) {
      const v = parseInt(value.replace(/[^0-9]/g, ''), 10);

      if (v !== this.currentPage) {
        this.currentPage = v;
      }
    },
  },
};
</script>

<style lang="scss">
// переменные не используются
// @import "src/assets/theme/default/reports/colors.scss";
// @import "src/assets/theme/default/reports/icons.scss";

.ui-pagination {
  display: flex;
  align-items: center;

  &__icon {
    font-size: 14px;
    width: 15px;
    text-align: center;
    color: var(--dark-green);
    cursor: pointer;

    &_disabled {
      pointer-events: none;
      opacity: .5;
      cursor: not-allowed;
    }
  }

  &__page-input {
    width: 39px !important;
    height: 34px;
    margin: 0 4px;

    .ui-input__element {
      text-align: center;
      padding: 8px 6px;
    }
  }

  &__label-info {
    font-size: 14px;
    white-space: nowrap;
  }

  @media (max-width: 650px) {
    display: none;
    width: 100%;
    justify-content: space-between;

    .el-select {
      width: 50%;
    }
  }
}
</style>
